import { Box, DialogContent, DialogContentText, Stack, styled, Typography } from '@mui/material';
import { ButtonComponent, colors, ModalUI, TextFieldComponent } from '@watter/shared-components';
import { useEffect, useState } from 'react';
import { useTranslation } from 'react-i18next';
import { useDispatch } from 'react-redux';
import { ADD_MACHINE_TO_CUSTOMER } from '../../graphql/mutation/customerMachine';
import { UPDATE_MACHINE_TO_CUSTOMER } from '../../graphql/mutation/customerMachine/updateMachineToCustomerMutation';
import { client } from '../../service/apolloClient';
import { hideLoader, showLoader } from '../../store/reducers/appSlice';
import { openToast } from '../../store/reducers/toastSlice';
import { IUpdateHeaterPopUpProps } from './type';
import { UpdateHeaterWrapper } from './update-heater-style';

const StackWrapper = styled(Stack)(() => ({
    '& .MuiBox-root ': {
        width: '100%',
    },
}));

export const HeaterNamePopup = ({
    open,
    closePopup,
    heading,
    userId,
    refetchCustomerDetail,
    isEdit,
    heaterIdValue,
}: IUpdateHeaterPopUpProps) => {
    const dispatch = useDispatch();
    const { t } = useTranslation();
    const [heaterId, setHeaterId] = useState(heaterIdValue || '');
    const [heaterIdError, setHeaterIdError] = useState(false);
    useEffect(() => {
        if (open) {
            if (isEdit) {
                setHeaterId(heaterIdValue || '');
            } else {
                setHeaterId('');
            }
            setHeaterIdError(false);
        }
    }, [open, isEdit, heaterIdValue]);

    const handleCloseVerifyPopUp = () => {
        closePopup();
        setHeaterId('');
        setHeaterIdError(false);
    };
    // Handle form submission
    const handleSubmit = async () => {
        if (!heaterId) {
            setHeaterIdError(true);
            return;
        }
        try {
            dispatch(showLoader());
            const input = {
                device_id: heaterId,
                customer_id: userId,
            };
            const { data } = await client.mutate({
                mutation: isEdit ? UPDATE_MACHINE_TO_CUSTOMER : ADD_MACHINE_TO_CUSTOMER,
                variables: { input },
            });
            dispatch(
                openToast({
                    show: true,
                    message: isEdit ? data?.updateDeviceToCustomer?.message : data?.addDeviceToCustomer?.message,
                    severity: 'success',
                    isAlertOpen: true,
                }),
            );
            handleCloseVerifyPopUp();
            refetchCustomerDetail();
        } catch (error) {
            dispatch(
                openToast({
                    show: true,
                    message: isEdit ? t('update_heater_fail') : t('add_heater_fail'),
                    severity: 'error',
                    isAlertOpen: true,
                }),
            );
            console.error('Failed', error);
        } finally {
            dispatch(hideLoader());
        }
    };

    const handleKeyDown = (event: any) => {
        if (event.key === 'Enter') {
            event.preventDefault();
        }
    };

    const onChangeHandler = (e: any) => {
        let { value } = e.target;
        value = value.replace(/\s+/g, ''); // Allow only alphanumeric characters and hyphens
        setHeaterId(value);
        setHeaterIdError(false);
    };
    return (
        <ModalUI
            open={open}
            onClose={handleCloseVerifyPopUp}
            aria-labelledby="alert-dialog-title"
            aria-describedby="alert-dialog-description"
            className="changePassword"
            onKeyDown={handleKeyDown}
        >
            <DialogContent>
                <DialogContentText id="alert-dialog-description">
                    <UpdateHeaterWrapper height="auto !important" container>
                        <Box className="feildsLabels" width="100%" height="auto !important">
                            <Box height="100%">
                                <Typography variant="h5" mb={1.5} className="header" textAlign="center">
                                    {heading}
                                </Typography>

                                <Box>
                                    <Stack>
                                        <Typography variant="subtitle1" color="info.100">
                                            {t('heater_id')}{' '}
                                            <Box component="span" color={colors.astric}>
                                                *
                                            </Box>
                                        </Typography>
                                        <TextFieldComponent
                                            name="heaterID"
                                            type="text"
                                            size="small"
                                            value={heaterId}
                                            placeholder={t('heater_id')}
                                            onChange={onChangeHandler}
                                        />

                                        {heaterIdError && (
                                            <Typography variant="caption" color="error" pt={0.5}>
                                                {t('heater_id_can_not_empty')}
                                            </Typography>
                                        )}
                                    </Stack>
                                    <StackWrapper
                                        direction={{ xs: 'column', sm: 'row' }}
                                        width="100%"
                                        gap={{ xs: 1.5 }}
                                        pt={5}
                                        pb={2.5}
                                        px={{ xs: 1.5, sm: 2.25 }}
                                    >
                                        <Box className="cstBtnWrapper">
                                            <ButtonComponent
                                                size="medium"
                                                variant="contained"
                                                fullWidth
                                                buttonName="cancel"
                                                className="cstBtn2"
                                                onClick={handleCloseVerifyPopUp}
                                            />
                                        </Box>
                                        <Box className="cstBtnWrapper">
                                            <ButtonComponent
                                                size="medium"
                                                variant="contained"
                                                fullWidth
                                                buttonName={t('save')}
                                                className="cstBtn"
                                                onClick={handleSubmit}
                                            />
                                        </Box>
                                    </StackWrapper>
                                </Box>
                            </Box>
                        </Box>
                    </UpdateHeaterWrapper>
                </DialogContentText>
            </DialogContent>
        </ModalUI>
    );
};

export default HeaterNamePopup;
